import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'

import { IDE_CONST, ROBOT_CONST } from './constants'
import { ACE_UTIL } from './ace-util'

export default {
  data: function () {
    return {
      isEmbed: false,
      codeEditor: null,
      fileEditor: null,
      outputEditor: null,
      editors: [],
      versionIndex: 0,
      args: null,
      stdin: null,
      isCodeExecuting: false,
      javaLibraries: [],
      outputFiles: [],
      executionTime: null,
      memory: 0,
      cpuTime: 0,
      wsNextId: 0,
      isLocalStoreEnabled: false,
      storage: null,
      files: [],
      itextVersion: '7.1.6'
    }
  },
  methods: {
    initEditors (count) {
      if (count > 10) {
        return
      }

      if (!window.ace) {
        this.$_.delay(this.initEditors, 500, count + 1)
        return
      }

      if (this.codeEditor && this.$route.meta.sampleScript) {
        this.codeEditor.getSession().setValue(this.$route.meta.sampleScript)
        ACE_UTIL.changeLanguage(this.codeEditor, this.aceLanguageCode)
      } else {
        this.initCodeEditor()
      }

      if (this.outputEditor) {
        this.outputEditor.getSession().setValue('')
        this.executionTime = null
      } else {
        this.initOutputEditor()
      }
      if (this.versions) {
        this.versionIndex = this.versions.length - 1
      }
    },
    initCodeEditor () {
      this.codeEditor = ACE_UTIL.initEditor(IDE_CONST.CODE_EDITOR, this.aceLanguageCode)
      this.codeEditor.renderer.setShowGutter(true)
      this.codeEditor.getSession().on('change', () => { ACE_UTIL.heightChangeFunction(IDE_CONST.CODE_EDITOR) })

      if (this.language === 'whitespace') {
        this.codeEditor.setShowInvisibles(true)
      }

      if (this.$route.meta.sampleScript) {
        this.codeEditor.getSession().setValue(this.$route.meta.sampleScript)
      }

      ACE_UTIL.heightChangeFunction(IDE_CONST.CODE_EDITOR, this.codeEditor)

      document.addEventListener('keyup', (event) => {
        if (event.ctrlKey && event.key === 'Enter') {
          this.execute()
        }
      }, false)
    },
    initOutputEditor () {
      this.outputEditor = ACE_UTIL.initEditor(IDE_CONST.OUTPUT_EDITOR)
      this.outputEditor.getSession().on('change', () => { ACE_UTIL.heightChangeFunction(IDE_CONST.OUTPUT_EDITOR) })
      this.outputEditor.renderer.setPadding(20)
      this.outputEditor.renderer.setScrollMargin(20, 20)
      this.outputEditor.setDisplayIndentGuides(false)

      ACE_UTIL.heightChangeFunction(IDE_CONST.OUTPUT_EDITOR, this.outputEditor)

      $(window.ace.edit(IDE_CONST.OUTPUT_EDITOR).textInput.getElement()).keypress((event) => {
        if (this.interactiveMode && this.isCodeExecuting) {
          let key = event.key
          if (event.key === 'Enter') {
            key = '\n'
          }
          this.socketClient.send('/app/execute-i', key, { message_type: 'input' })
        }
      })
    },
    tryExecute () {
      if (this.isCodeExecuting) {
        return
      }

      this.isCodeExecuting = true
      this.executionTime = null
      this.outputFiles = []
      this.showOutput = true
      window.ace.edit(IDE_CONST.OUTPUT_EDITOR).getSession().setValue('')

      this.callViaCaptcha(this.executeInteractive, this.captchaFailCallback)
    },
    captchaFailCallback () {
      window.ace.edit(IDE_CONST.OUTPUT_EDITOR).getSession().setValue(ROBOT_CONST.ROBOT_IDE_ERROR)
      this.isCodeExecuting = false
    },
    postExecuteSuccessHandling () {

    },
    executeInteractive () {
      this.socketClient = Stomp.over(new SockJS('/engine/stomp'), { heartbeat: false, debug: false })

      this.wsNextId = 0

      let startTime = 0
      try {
        if (window.performance) {
          startTime = performance.now()
        }
      } catch (e) {
        startTime = $.now()
      }

      let libraries = _.clone(this.javaLibraries)
      let data = {
        script: window.ace.edit(IDE_CONST.CODE_EDITOR).getSession().getValue(),
        args: this.args,
        language: this.language,
        libs: libraries,
        versionIndex: 0,
        projectKey: 1001,
        hasInputFiles: (this.inputFiles.length > 0)
      }

      // TODO : pageView for interactive call
      this.socketClient.connect({}, () => {
        this.onWsConnection(startTime, data)
      }, this.onWsConnectionFailed)
    },
    onWsConnectionFailed (e) {
      this.isCodeExecuting = false
      window.ace.edit('output').insert('Connection to server lost.\nIt is possible your browser or internet connection may not support the ' +
        'Interactive mode.\nPlease try again, or try Non-Interactive mode. Alternatively contact JDoodle ' +
        'support at jdoodle@nutpan.com.')
    },
    postInteractiveExecute (startTime) {
      this.socketClient.disconnect()
      this.isCodeExecuting = false

      // TODO : pageView for interactive call completion

      // eslint-disable-next-line no-unused-vars
      let execTime
      try {
        if (window.performance) {
          execTime = performance.now() - startTime
        }
      } catch (e) {
        execTime = $.now() - startTime
      }

      // TODO : pageView for interactive call execute time
      this.postExecuteSuccessHandling()
    },
    onWsConnection (startTime, data) {
      this.socketClient.subscribe('/user/queue/execute-i', (message) => {
        let msgId = message.headers['message-id']
        let msgSeq = parseInt(msgId.substring(msgId.lastIndexOf('-') + 1))

        let statusCode = parseInt(message.headers.statusCode)

        if (statusCode === 201) {
          this.wsNextId = msgSeq + 1
          return
        }

        let t0
        try {
          t0 = performance.now()
          while ((performance.now() - t0) < 2500 && this.wsNextId !== msgSeq) {

          }
        } catch (e) {

        }

        if (statusCode === 204) {
          this.executionTime = message.body
          this.postInteractiveExecute(startTime)
        } else if (statusCode === 206) {
          this.outputFiles = JSON.parse(message.body)
        } else if (statusCode === 403) {
          this.clearRobotCheckStatus()
          window.ace.edit('output').insert('' + message.body)
        } else if (statusCode !== 410) {
          window.ace.edit('output').insert('' + message.body)
        }

        this.wsNextId = msgSeq + 1
      })

      this.socketClient.send('/app/execute-i', JSON.stringify(data), { message_type: 'execute' })
      window.ace.edit('output').focus()
    },
    reset () {
      window.ace.edit(IDE_CONST.CODE_EDITOR).getSession().setValue('')
      window.ace.edit(IDE_CONST.OUTPUT_EDITOR).getSession().setValue('')
      this.args = null
      this.stdin = null
      this.javaLibraries = []
      this.executionTime = null
      this.memory = 0
      this.cpuTime = 0
    },
    addToRecent: function (lastExecution) {
      if (this.isEmbed) {
        return
      }
      var recent = JSON.parse(this.storage.getItem('JDoodleRecent'))
      if (!recent) {
        recent = {}
      }

      if (!recent[this.language]) {
        recent[this.language] = []
      }

      recent[this.language].unshift(lastExecution)
      if (recent[this.language].length > 50) {
        recent[this.language] = _.slice(recent[this.language], 0, 50)
      }

      this.storage.setItem('JDoodleRecent', JSON.stringify(recent))
    }
  }
}
